<template>
	<div v-if="isThreadCreated" class="thread-created-system-text">
		<template v-if="message.systemevent === 'THREAD_CONVERTED'">
			<i18n-t
				v-if="message.systemmessageparts?.message_count"
				keypath="model_systemevent_threadconverted_count.variable"
				:plural="message.systemmessageparts.message_count"
			>
				<template #name>
					<span class="thread-created-who">{{
						message.systemmessageparts?.who_name
					}}</span>
				</template>
				<template #count>{{
					message.systemmessageparts.message_count
				}}</template>
			</i18n-t>
			<i18n-t v-else keypath="model_systemevent_threadconverted">
				<span class="thread-created-who">{{
					message.systemmessageparts?.who_name
				}}</span>
			</i18n-t>
		</template>
		<i18n-t v-else keypath="model_systemevent_threadcreated">
			<span class="thread-created-who">{{
				message.systemmessageparts?.who_name
			}}</span>
		</i18n-t>
	</div>

	<div v-else-if="isStyled && !isLinkEvent" class="message-text-system-new">
		{{ messageText }}
	</div>

	<div
		v-else-if="
			isStyled && isLinkEvent && message.systemevent !== 'BUBBLE_ADDED_MANY'
		"
		class="message-text-system-new"
	>
		{{ prefix }}
		<span
			v-if="message.systemmessageparts"
			@click="$emit('open-profile', message.systemmessageparts.who_id)"
			>{{ message.systemmessageparts.who_name }}</span
		>
	</div>

	<div
		v-else-if="isStyled && message.systemevent === 'BUBBLE_ADDED_MANY'"
		class="message-text-system-new"
	>
		<span
			v-if="message.systemmessageparts"
			@click="$emit('open-profile', message.systemmessageparts.invitedby_id)"
			>{{ message.systemmessageparts.invitedby_name }}</span
		>
		{{ messageText }}
	</div>

	<div v-else-if="message.systemevent" class="message-text-system">
		{{ message.message }}
	</div>
</template>

<script>
import {
	isStyledSystemEvent,
	isThreadCreatedEvent,
	isSystemLinkEvent,
	systemMessage,
	systemMessagePrefix,
} from './utils'

export default {
	name: 'SystemMessageBody',

	props: {
		message: { type: Object, required: true },
	},

	emits: ['open-profile'],

	computed: {
		isThreadCreated() {
			return isThreadCreatedEvent(this.message)
		},
		isStyled() {
			return isStyledSystemEvent(this.message)
		},
		isLinkEvent() {
			return isSystemLinkEvent(this.message)
		},
		messageText() {
			return systemMessage(this.message)
		},
		prefix() {
			return systemMessagePrefix(this.message)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.message-text-system {
	margin-top: 4px;
	font-family: Avenir-Oblique;
	font-size: 14px;
	color: #b7b9bd;
	user-select: none;
}

.message-text-system-new {
	font-family: Avenir-Oblique;
	font-size: 17px;
	color: var(--neutral-400);
	font-weight: normal !important;
}

.message-text-system-new span {
	text-decoration: underline;
	cursor: pointer;
}

.thread-created-system-text {
	font-family: Avenir-Medium;
	font-size: 12px;
	color: var(--neutral-600);
	padding-top: 3px;
	padding-bottom: 2px;

	.thread-created-who {
		font-family: Avenir-Heavy;
		color: var(--neutral-800);
	}
}
</style>
